/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Installation from './Installation/index'
import Preview from './Preview/index'
import Questions from './Questions/index'
import React from 'react'
import Settings from './Settings/index'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Questions'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-2-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--mt-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="medium"
 text="Questions"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Questions'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Questions'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="medium"
 text="Settings"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Settings'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Settings'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="medium"
 text="Preview"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Preview'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Preview'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="medium"
 text="Installation"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Installation'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Installation'))}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-2-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'Questions'}>
<Questions
  viewPath={`${viewPath}/Questions`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Settings'}>
<Settings
  viewPath={`${viewPath}/Settings`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Preview'}>
<Preview
  viewPath={`${viewPath}/Preview`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Installation'}>
<Installation
  viewPath={`${viewPath}/Installation`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}